"use client";

import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { AuthProvider } from "./context/AuthContext";
import PrivateRoute from "./components/auth/PrivateRoute";
import RoleBasedRoute from "./components/auth/RoleBasedRoute";
import ErrorBoundary from "./components/common/ErrorBoundary";
import Layout from "./components/layout/Layout";
import Dashboard from "./pages/Dashboard";
import Courses from "./pages/Courses";
import Attendance from "./pages/Attendance";
import Payments from "./pages/Payments";
import Login from "./pages/Login";
import ForgotPasswordPage from "./pages/ForgotPassword";
import Students from "./pages/Students";
import UserManagement from "./pages/UserManagement";
import Certifications from "./pages/Certificates"; // Import the Certificates page
import { testApiConnection } from "./utils/testConnection";

function App() {
  useEffect(() => {
    testApiConnection();
    console.log("API URL:", process.env.REACT_APP_API_URL);
  }, []);

  return (
    <ErrorBoundary>
      <Router>
        <AuthProvider>
          <ToastContainer position="top-right" autoClose={5000} />
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/auth/forgot-password" element={<ForgotPasswordPage />} />

            {/* Protected Routes */}
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Layout />
                </PrivateRoute>
              }
            >
              {/* Dashboard - Only Admin/Accountant */}
              <Route
                index
                element={
                  <RoleBasedRoute allowedRoles={["Admin", "Accountant"]}>
                    <Dashboard />
                  </RoleBasedRoute>
                }
              />

              {/* Admin Only */}
              <Route
                path="users"
                element={
                  <RoleBasedRoute allowedRoles={["Admin"]}>
                    <UserManagement />
                  </RoleBasedRoute>
                }
              />

              {/* Coordinator/Instructor Routes */}
              <Route
                path="students"
                element={
                  <RoleBasedRoute allowedRoles={["Admin", "Coordinator"]}>
                    <Students />
                  </RoleBasedRoute>
                }
              />

              {/* Instructor Routes */}
              <Route
                path="attendance"
                element={
                  <RoleBasedRoute allowedRoles={["Admin", "Instructor"]}>
                    <Attendance />
                  </RoleBasedRoute>
                }
              />

              {/* Teacher/Course Manager Routes */}
              <Route
                path="courses"
                element={
                  <RoleBasedRoute allowedRoles={["Admin", "Instructor"]}>
                    <Courses />
                  </RoleBasedRoute>
                }
              />

              {/* Accountant Routes */}
              <Route
                path="payments"
                element={
                  <RoleBasedRoute allowedRoles={["Admin", "Accountant"]}>
                    <Payments />
                  </RoleBasedRoute>
                }
              />

              {/* Certificates Route - Admin and Coordinator */}
              <Route
                path="certifications"
                element={
                  <RoleBasedRoute allowedRoles={["Admin", "Coordinator"]}>
                    <Certifications />
                  </RoleBasedRoute>
                }
              />
            </Route>
          </Routes>
        </AuthProvider>
      </Router>
    </ErrorBoundary>
  );
}

export default App;